import {
  createRequestCollectMessaging,
  createRequestResponseMessaging
} from '@passionware/messaging-react';
import { MessageService } from './MessageService';
import { createSimpleEvent } from '@passionware/simple-event';

export function createMessageService(): MessageService {
  return {
    createCustomField: createRequestResponseMessaging(),
    mountElement: createRequestResponseMessaging(),
    reportSystemEffect: createRequestCollectMessaging(),
    reportCache: createSimpleEvent()
  };
}
